export const customStorage = {
  getItem: (name) => {
    const value = localStorage.getItem(name);
    return value ? JSON.parse(value) : null; // Deserialize
  },
  setItem: (name, value) => {
    localStorage.setItem(name, JSON.stringify(value)); // Serialize
  },
  removeItem: (name) => {
    localStorage.removeItem(name);
  },
};

export const isValidApiKey = (key) => {
  if (!key || typeof key !== "string") return false;

  // Must not be empty after trimming
  if (key.trim().length === 0) return false;

  // Optional: Basic Google Maps API key pattern check
  // Valid keys usually start with "AIza"
  if (!key.startsWith("AIza")) return false;

  return true;
};
export const getCurrentDate = () => {
  return new Date().toISOString().split("T")[0];
};

export const mainCategories = [
  "Electronics",
  "Furniture",
  "Clothing and Apparel",
  "Health and Beauty",
  "Food and Beverages",
  "Automotive",
  "Sports and Outdoors",
  "Toys and Games",
  "Books and Stationery",
  "Home and Garden",
  "Pet Products",
  "Jewelry and Watches",
  "Office Supplies",
  "Baby Products",
  "Industrial and Scientific",
  "Hardware and Tools",
  "Technology",
  "Travel and Luggage",
  "Office Equipment",
];
export const extractOrderNumber = (str) => {
  const match = str.match(/\d+/); // This will match the first sequence of digits in the string
  return match ? parseInt(match[0], 10) : null; // Convert the matched string to an integer, removing any leading zeros
};
